module.exports = __webpack_public_path__ + "static/media/new_account_details.2242bec9.svg";